import { Helmet } from 'react-helmet';
import MachuyentienDetail
  from 'src/components/machuyentien-detail/MachuyentienDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import MachuyentienListToolbar from '../components/machuyentien-detail/MachuyentienToolbar';

const Machuyentien = () => (
  <>
    <Helmet>
      <title>Autobank</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        {/* <MachuyentienListToolbar /> */}
        <Box sx={{ pt: 3 }}>
          <MachuyentienDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Machuyentien;
